module.exports = __webpack_public_path__ + "img/huanghuagang.6be88900.jpg";